import { render, staticRenderFns } from "./RenegociationPret.vue?vue&type=template&id=6590b99a&"
import script from "./RenegociationPret.vue?vue&type=script&lang=js&"
export * from "./RenegociationPret.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports